import React from 'react';

const Services: React.FC = () => {
    return (
        <div className="container">
            <h1 className="text-center mb-4 animate__animated animate__fadeInDown">Services</h1>
            
            <div className="row">
                <div className="col-md-6 mb-4">
                    <div className="card h-100 animate__animated animate__fadeInUp">
                        <div className="card-header bg-success text-white">
                            <h5>Personal Security Guard / Commercial Security Guards (24/7)</h5>
                        </div>
                        <div className="card-body">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">House security guard</li>
                                <li className="list-group-item">Personal security officer (Bodyguard/Bouncer)</li>
                                <li className="list-group-item">Armed security service (Gunman/Rifleman)</li>
                                <li className="list-group-item">Security guard services (Office/Warehouse/Factory)</li>
                                <li className="list-group-item">Armed security services for (Office/Warehouse/Factory)</li>
                                <li className="list-group-item">Bouncer security service for (Pub, Restaurants & Bars)</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card h-100 animate__animated animate__fadeInUp" style={{animationDelay: '0.2s'}}>
                        <div className="card-header bg-success text-white">
                            <h5>Event Security Services</h5>
                        </div>
                        <div className="card-body">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">Security guard</li>
                                <li className="list-group-item">Bouncer security</li>
                                <li className="list-group-item">Rifle-man / Gunman security</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card h-100">
                        <div className="card-header bg-success text-white">
                            <h5>Security Escort Services</h5>
                        </div>
                        <div className="card-body">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">Assist client during travel</li>
                                <li className="list-group-item">Personal protection & safety</li>
                                <li className="list-group-item">Travel escort & movement security</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-4">
                    <div className="card h-100">
                        <div className="card-header bg-success text-white">
                            <h5>Professional Manpower Services</h5>
                        </div>
                        <div className="card-body">
                            <h6 className="text-primary">Office & Administrative Support</h6>
                            <ul className="list-group list-group-flush mb-3">
                                <li className="list-group-item">Office boys / office assistants</li>
                                <li className="list-group-item">Receptionists</li>
                                <li className="list-group-item">Data entry operators</li>
                                <li className="list-group-item">Front desk executives</li>
                            </ul>
                            <h6 className="text-primary">Housekeeping & Others</h6>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">Housekeepers & Cleaners</li>
                                <li className="list-group-item">Gardeners</li>
                                <li className="list-group-item">Cooks</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;